/// <reference path="../../_references.ts" />
module onvio.setup.activities {
    'use strict';

    export class ActivityListController implements bmp.IMasterViewController {

        private definition: bmp.IGridDefinition;

        static $inject = [
            '$scope',
            '$location',
            'csActivityV1',
            'bmpFeatureToggles',
            'resolve.translationsLoaded'
        ];
        constructor(
            private $scope: ng.IScope,
            private $location: ng.ILocationService,
            private activityV1: cs.IActivityV1Service,
            private featureToggles: bmp.IFeatureTogglesService,
            translationsLoaded: any) {

            featureToggles.isFeatureEnabledAsyncAndRedirect('OnvioSetup', 'Activities');

            // NOTE: When we tried doing the i18nextract comment inline in the definition,
            // the generated typescript added a space between the comment and the key, which makes the extraction fail.
            // This block of comments needs to be kept in sync with the titles below.
            // /* i18nextract */'Core.Captions.Activity.ClassOther',
            // /* i18nextract */'Bluemoon.Setup.Activities.List.DeleteConfirmationMessage';
            // /* i18nextract */'Core.Captions.Activity.Code',
            // /* i18nextract */'Core.Captions.Activity.Name',
            // /* i18nextract */'Core.Captions.Activity.ActivityType',
            // /* i18nextract */'Core.Captions.Activity.Class',
            // /* i18nextract */'Core.Captions.Activity.RateType',
            this.definition = {
                gridName: 'ActivityGrid',
                analyticsContext: 'setup_activity',
                title: 'Core.Captions.Activity.ClassOther',
                deletionMessage: 'Bluemoon.Setup.Activities.List.DeleteConfirmationMessage',
                primaryKey: 'activityId',
                orderBy: 'code asc',
                expansions: undefined,
                route: '#/setup/activities',
                columns: [
                    {
                        title: 'Core.Captions.Activity.Code',
                        dataProperty: 'code',
                        search: true,
                        shrink: true,
                        width:'195'
                    },
                    {
                        title: 'Core.Captions.Activity.Name',
                        dataProperty: 'name',
                        search: true,
                        width: '*'
                    },
                    {
                        title: 'Core.Captions.Activity.ActivityType',
                        dataProperty: 'activityType.name',
                        search: true,
                        width: '*'
                    },
                    {
                        title: 'Core.Captions.Activity.Class',
                        dataProperty: 'class.name',
                        search: true,
                        width: '*'
                    },
                    {
                        title: 'Core.Captions.Activity.RateType',
                        dataProperty: 'rateType.name',
                        search: true,
                        width: '*'
                    }
                ]
            };

        }

        /* Returns the definition for the grid */
        public getDefinition(): bmp.IGridDefinition {
            return this.definition;
        }

        /* Returns the service for the grid */
        public getService(): bmp.IRepositoryService {
            return <bmp.IRepositoryService>this.activityV1;
        }

    }

    angular.module('onvio.setup.activities.ActivityListController',
        [
            'pascalprecht.translate',
            'bmTranslateEventUtils',
            'csActivityV1',
            'ui.router'
        ])

        .controller('onvio.setup.activities.ActivityListController',
            ActivityListController)

        .config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
            $stateProvider.state('setup-activities', {
                url: '/setup/activities',
                templateUrl: 'bmp/bmp-master-detail/bmp-master-view.html',
                controller: 'onvio.setup.activities.ActivityListController as vm',
                reloadOnSearch: false,
                resolve: {
                    'resolve.translationsLoaded': ['bmTranslateEventUtils',
                        (bmTranslateEventUtils: any) => {
                            return bmTranslateEventUtils.loadEnd();
                        }]
                }
            });
        }]);
}
